module.exports = "/img/background-2.b37cc871.png";